export default __webpack_public_path__ + "static/media/146.aac4b327.jpg";